import { applicationManagementApi } from "./apis/applicationManagementApis";
import { authApi } from "./apis/authApis";
import { brandApi } from "./apis/brandApis";
import { categoryApi } from "./apis/categoryApis";
import { configureStore } from "@reduxjs/toolkit";
import { dayoffApi } from "./apis/dayoffApis";
import { departmentApi } from "./apis/departmentApis";
import { enterDateReducer } from "./slices/enterDateSlice";
import { equipmentApi } from "./apis/equipmentsApi";
import { modelApi } from "./apis/modelApis";
import { setupListeners } from "@reduxjs/toolkit/query";
import { teamApi } from "./apis/teamApi";
import { userApi } from "./apis/userApis";
import { userReducer } from "./slices/user/userSlice";
import { toastReducer } from "./slices/toast/toastSlice";
import { dialogReducer } from "./slices/dialog/dialogSlice";
import { permissionGridReducer } from "./slices/permissionGrid/permissionGridSlice";
import { managementReducer } from "./slices/applicationManagement/managementSlice";
import { dashboardApi } from "./apis/dashboardApi";

export const store = configureStore({
  reducer: {
    [userApi.reducerPath]: userApi.reducer,
    [dayoffApi.reducerPath]: dayoffApi.reducer,
    [departmentApi.reducerPath]: departmentApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [applicationManagementApi.reducerPath]: applicationManagementApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
    [brandApi.reducerPath]: brandApi.reducer,
    [modelApi.reducerPath]: modelApi.reducer,
    [equipmentApi.reducerPath]: equipmentApi.reducer,
    [teamApi.reducerPath]: teamApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    userSlice: userReducer,
    enterDateSlice: enterDateReducer,
    toastSlice: toastReducer,
    dialogSlice: dialogReducer,
    permissionGridSlice: permissionGridReducer,
    managementSlice: managementReducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware()
      .concat(userApi.middleware)
      .concat(dayoffApi.middleware)
      .concat(departmentApi.middleware)
      .concat(authApi.middleware)
      .concat(categoryApi.middleware)
      .concat(brandApi.middleware)
      .concat(modelApi.middleware)
      .concat(equipmentApi.middleware)
      .concat(applicationManagementApi.middleware)
      .concat(teamApi.middleware)
      .concat(dashboardApi.middleware);
  },
});

setupListeners(store.dispatch);

export {
  useFetchMainInformationQuery,
  useFetchPersonelsQuery,
  usePostUserMutation,
  useDeleteUserMutation,
  useUpdatePasswordMutation,
  useFetchGetUsersQuery,
  useFetchGetUserDetailQuery,
  useFetchGetUserEquipmentsForEditQuery,
  useFetchUserEquipmentsQuery,
  useEnterDateMutation,
  useFetchUserDayoffsQuery,
  useUserRightBulkUpdateMutation,
  useFetchUserForUpdateQuery,
  useFetchUsedEquipmentsQuery,
  useDeleteUsedEquipmentMutation,
  useGiveBackEquipmentMutation
} from "./apis/userApis";

export {
  useFetchPermissionListQuery,
  useFetchDayoffListQuery,
  useFetchGetDayoffQuery,
  usePostDayoffMutation,
  useDeleteDayoffMutation,
  useApproveDayoffMutation,
  useFetchPersonelRightsQuery,
  useFetchDayoffDocumentsQuery,
  useFetchPersonelPeriodsQuery,
  useRenewDayoffMutation,
  useEnterBulkDayoffMutation,
  useLazyFetchReportQuery,
  useLazyFetchExportToExcelQuery,
  useFetchGetLastPeriodOfUserQuery,
  useLazyFetchSystemFormQuery
} from "./apis/dayoffApis";

export {
  useFetchDepartmentsQuery,
  usePostDepartmentMutation,
  usePutDepartmentMutation,
  useDeleteDepartmentMutation,
  useFetchDepartmentQuery,
} from "./apis/departmentApis";

export {
  useFetchMeQuery,
  useLogoutMutation,
  useLoginMutation,
  useGoogleAuthMutation,
} from "./apis/authApis";

export {
  useFetchDayoffTypeDocumentsQuery,
  useFetchGetDayoffTypesQuery,
  useFetchGetDocumentTypesQuery,
  useFetchGetDayoffTypeDocumentsQuery,
  usePostDayoffTypesMutation,
  useDeleteDayoffTypesMutation,
  usePostDocumentTypeMutation,
  useDeleteDocumentTypeMutation,
  usePostDayoffTypeDocumentsMutation,
  useDeleteDayoffTypeDocumentMutation,
} from "./apis/applicationManagementApis";

export {
  useFetchCategoriesQuery,
  usePostCategoryMutation,
  useDeleteCategoryMutation,
} from "./apis/categoryApis";

export {
  useDeleteBrandMutation,
  useFetchBrandsQuery,
  usePostBrandMutation,
} from "./apis/brandApis";

export {
  useDeleteModelMutation,
  useFetchModelsQuery,
  usePostModelMutation,
} from "./apis/modelApis";

export {
  useDeleteEquipmentMutation,
  useFetchGroupedEquipmentsQuery,
  useFetchEquipmentsQuery,
  usePostEquipmentMutation,
  useFetchEquipmentByCategoryIdQuery,
} from "./apis/equipmentsApi";

export {
  useFetchTeamsQuery,
  useFetchTeamByUserIdQuery,
  useCreateTeamMutation,
  useDeleteTeamMutation,
} from "./apis/teamApi";

export {
  useFetchActivePanelsQuery,
  useFetchSystemSummaryQuery,
  useFetchQuestionnairesQuery,
  useCreatePanelMutation,
  useDeletePanelMutation,
} from "./apis/dashboardApi";
